var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home mb-4"},[_c('br'),_c('div',{staticClass:"d-flex mx-auto row"},_vm._l((this.$store.state.perCategory),function(product,idx){return _c('MenCard',{key:idx,attrs:{"product":product}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }